import { exportToCsv } from '../../../util/export';
import { AbsenceProposal } from '../../../models/AbsenceProposal';
import { ContactId } from '../../../models/Types';
import { Contact } from '../../../models/Contact';
import useContactsContext from '../../contacts/hooks/useContactsProvider';
import moment from 'moment';
import i18n from '../../../i18n';

export const exportAbsenceProposalsToCsv: (
  absenceProposals: AbsenceProposal[],
  getContactById: (contactId: ContactId) => Contact | null,
  type: 'openproposals' | 'allproposals'
) => void = (absenceProposals, getContactById, type) => {
  const dataRows: string[][] = absenceProposals.map((absenceProposal) => {
    if (absenceProposal) {
      const applicant = absenceProposal.applicantId
        ? getContactById(absenceProposal.applicantId)
        : null;
      const principal = absenceProposal.principalId
        ? getContactById(absenceProposal.principalId)
        : null;
      const substitute = absenceProposal.substituteId
        ? getContactById(absenceProposal.substituteId)
        : null;
      return [
        `${applicant?.firstName} ${applicant?.lastName}`,
        `${i18n.t(`absences:types.${absenceProposal.absenceType}`)}`,
        absenceProposal.from === absenceProposal.to
          ? moment(absenceProposal.from).format('DD.MM.YYYY')
          : moment(absenceProposal.from).isSame(
                moment(absenceProposal.to),
                'month'
              )
            ? `${moment(absenceProposal.from).format('DD.')} - ${moment(
                absenceProposal.to
              ).format('DD.MM.YYYY')}`
            : moment(absenceProposal.from).isSame(
                  moment(absenceProposal.to),
                  'year'
                )
              ? `${moment(absenceProposal.from).format('DD.MM.')} - ${moment(
                  absenceProposal.to
                ).format('DD.MM.YYYY')}`
              : `${moment(absenceProposal.from).format(
                  'DD.MM.YYYY'
                )} - ${moment(absenceProposal.to).format('DD.MM.YYYY')}`,
        `${absenceProposal.absentWorkdays.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })}`,
        `${principal?.firstName} ${principal?.lastName}`,
        `${substitute?.firstName} ${substitute?.lastName}`,
        absenceProposal.firstIsHalfDay === true
          ? i18n.t('absences:officeHolidays.table.export.isHalfDayYes')
          : i18n.t('absences:officeHolidays.table.export.isHalfDayNo'),
        absenceProposal.lastIsHalfDay === true
          ? i18n.t('absences:officeHolidays.table.export.isHalfDayYes')
          : i18n.t('absences:officeHolidays.table.export.isHalfDayNo'),
        absenceProposal.note || '',
      ];
    }
    return [];
  });

  const headers = [
    i18n.t('absences:absenceManagement.table.columnTitle.applicantId'),
    i18n.t('absences:absenceManagement.table.columnTitle.absenceType'),
    i18n.t('absences:absenceManagement.table.columnTitle.period'),
    i18n.t('absences:absenceManagement.table.columnTitle.days'),
    i18n.t('absences:absenceManagement.table.columnTitle.principalId'),
    i18n.t('absences:absenceManagement.table.columnTitle.substituteId'),
    i18n.t('absences:absenceManagement.table.columnTitle.firstIsHalfDay'),
    i18n.t('absences:absenceManagement.table.columnTitle.lastIsHalfDay'),
    i18n.t('absences:absenceManagement.table.columnTitle.note'),
  ];
  exportToCsv(
    headers,
    dataRows,
    i18n.t(`absences:hrAbsenceMenu.navigation.${type}`)
  );
};

export function useExportAbsenceProposalsToCsv(): (
  absenceProposals: AbsenceProposal[],
  type: 'openproposals' | 'allproposals'
) => void {
  const { getContactById } = useContactsContext();

  return (
    absenceProposals: AbsenceProposal[],
    type: 'openproposals' | 'allproposals'
  ) => exportAbsenceProposalsToCsv(absenceProposals, getContactById, type);
}
